import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';
import {Button, Typography} from 'views/components';
import {Translate} from 'views/module';

const ReactivateAuth = (props) => {
  const [isSetting, setIsSetting] = React.useState(false);

  const onClose = props.onClose;
  const addAuth = props.addAuth;

  const onSubmit = () => {
    setIsSetting(true);
    addAuth();
  };

  return (
    <Dialog onClose={onClose} open={true}>
      <DialogTitle onClose={onClose}>
        <Translate expression='caregiver.CaregiverDetail.Settings.Auth.ReactivateAuth' />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='caregiver.CaregiverDetail.Settings.Auth.ReactivateAuthText'/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={onSubmit}
          loading={isSetting}
        >
          <Translate expression='caregiver.CaregiverDetail.Settings.Auth.ReactivateAuth' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ReactivateAuth.propTypes = {
  onClose: PropTypes.func.isRequired,
  addAuth: PropTypes.func.isRequired,
};

export default React.memo(ReactivateAuth);
